export default "__VITE_ASSET__pLVq56rD__"